export const getDisplayName = (name) => {
    const nameMap = {
        songStructure: "form",
        tempoAdjustment: "adjustment",
        intensityOfChords: "chord rate",
        intensityOfMelody: "melody rate",
        motiveComplexityOfMelody: "melody",
        motiveComplexityOfChords: "chord",
        "overall extended chord rate": "overall",
        "7th chord rate": "7th",
        "9th chord rate": "9th",
        "11th chord rate": "11th",
        "13th chord rate": "13th",
        chordRepetitionForPart: "part",
        chordRepetitionForMelody: "melody",
        chordRepetitionForMotive: "motive",
        majorChordRate: "major",
        minorChordRate: "minor",
        diminishedChordRate: "diminished",
        augmentedChordRate: "augmented",
        color: "color",
    }
    return nameMap[name] || name
}

export const getKeySetting = (style) => {
    return style.find((setting) => setting.name === "key")
}

export const getKey = (style) => {
    return getKeySetting(style).value
}

export const getKeys = (style) => {
    return getKeySetting(style).possibleValues
}

export const getKeyAsInt = (style) => {
    const keys = getKeys(style)
    const key = getKey(style)

    return keys.indexOf(key)
}

export const getRoots = (style) => {
    return style.find((setting) => setting.name === "root")
        .possibleValues
}

export const getRoot = (style) => {
    return style.find((setting) => setting.name === "root").value
}
